var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mensajeAlert py-3"},[_c('router-link',{attrs:{"to":"/condiciones"}},[_c('p',{staticClass:"m-0 bodyText fontLightExotics"},[_vm._v(" Al preguntar aceptas los Términos y condiciones y las Políticas de privacidad de Exotics Co. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }